module.exports = __webpack_public_path__ + "static/media/loader.3f259006.gif";